import * as React from "react";
import { cn } from "@/lib/utils";
import { FIELD_LABEL_CLASS } from "./section-header";

/** Canon field: 4px corners, hairline, bg, px-2 py-1, 13px. The look of every input / select / textarea. */
export const FIELD_CLASS =
  "min-w-0 rounded border border-line bg-background px-2 py-1 text-body-s text-fg placeholder:text-dim focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50";

/** The one dropdown: a native <select> in the field style (prototype `select`). */
export const SelectField = React.forwardRef<HTMLSelectElement, React.SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, ...props }, ref) => <select ref={ref} className={cn(FIELD_CLASS, "h-7 pointer-coarse:h-9", className)} {...props} />,
);
SelectField.displayName = "SelectField";

/** Canon `.field`: a caps `.k` label above the control. */
export function Field({ label, className, children, ...props }: React.LabelHTMLAttributes<HTMLLabelElement> & { label: React.ReactNode }) {
  return (
    <label className={cn("flex flex-col gap-1", className)} {...props}>
      <span className={FIELD_LABEL_CLASS}>{label}</span>
      {children}
    </label>
  );
}
